var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashLargeBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148713",
    "data-name": "Rectangle 148713",
    width: 32,
    height: 32,
    transform: "translate(0.034 -0.035)",
    fill: "#0c0c0b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-0.034 0.035)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "garbage",
    transform: "translate(5.762 4.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11940",
    "data-name": "Group 11940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_53",
    "data-name": "Subtraction 53",
    d: "M15.246,22.991H5.2a3.416,3.416,0,0,1-3.413-3.412V4.584H.64A.64.64,0,0,1,0,3.948a.633.633,0,0,1,.64-.639H5.425V2.528A2.531,2.531,0,0,1,7.953,0H12.5A2.533,2.533,0,0,1,15.03,2.528v.781h4.781a.633.633,0,0,1,.64.639.64.64,0,0,1-.64.637H18.659V19.578A3.416,3.416,0,0,1,15.246,22.991ZM10.225,6.872a.639.639,0,0,0-.636.641V18.782a.638.638,0,1,0,1.276.008V7.513A.634.634,0,0,0,10.225,6.872Zm4.165.7a.638.638,0,0,0-.636.637v9.876a.63.63,0,0,0,.636.637.64.64,0,0,0,.64-.637V8.209A.64.64,0,0,0,14.39,7.572Zm-8.329,0a.638.638,0,0,0-.636.637v9.876a.638.638,0,0,0,1.276,0V8.209A.64.64,0,0,0,6.061,7.572Zm1.892-6.3A1.253,1.253,0,0,0,6.7,2.528v.781h7.053V2.528A1.255,1.255,0,0,0,12.5,1.276Z",
    fill: "#0c0c0b"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLargeBlack);
export default __webpack_public_path__ + "static/media/trash-large-black.07b928c7.svg";
export { ForwardRef as ReactComponent };